import { ReactElement } from 'react';
import { MaintenanceLayout } from '~/pages/Analysis/Maintenance/Layout';

export function AnalysisMaintenance(): ReactElement {
  return <MaintenanceLayout />;
}
